// libs
import { styled } from '@nykaa/ui-components';
import { BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.span<{
  borderColor: string;
  bgColor: string;
  transparency_web: number;
  saleExp?: boolean;
}>`
  ${({ borderColor, saleExp }) => saleExp ? `border: none` : `border: 1px solid ${borderColor}`};
  ${({ transparency_web }) => `opacity: ${transparency_web}`};
  ${({ bgColor }) => `background: ${bgColor}`};

  border-radius: ${({ theme }) => theme.borders.radius10};
  display: inline-flex;
  align-items: center;
  padding: ${({ theme }) => `${theme.spacing.spacing10} ${theme.spacing.spacing20}`};
  min-height: 16px;
  margin-right: ${({ theme }) => theme.spacing.spacing20};
  align-self: start;

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    &:first-child {
      margin-bottom: ${({ theme }) => theme.spacing.spacing10};
    }
  }
  .tag-title {
    margin: 0;
    ${({ theme }) => theme.typography.labelSmall};
    color: ${({ theme }) => theme.colors.primary};
    display: block;
  }

  @media screen and (max-width: 370px) {
    &:nth-of-type(n + 2) {
      display: none;
    }
  }

  &:nth-last-of-type(1) {
    margin-right: 0px;
  }

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 20px;
    .tag-title {
      ${({ theme }) => theme.typography.subTitleSmall};
    }
  }
`;

export const Title = styled.span<{
  titleColor: string;
}>`
  margin: 0;
  ${({ theme }) => theme.typography.labelSmall};
  color: ${({ titleColor, theme }) => (titleColor ? titleColor : theme.colors.textPrimary)};
  display: block;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.subTitleSmall};
  }
`;
